import iconsCore from 'assets/images/icons';

export const icons = { ...iconsCore };

export default icons;
